import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createSelector } from "reselect";
import {
  clearAllReferralDetail,
  rejectRefferalByID,
  viewAllReferralDetail,
} from "../../../../redux/action";
import constant from "../../../../constants/constant";

interface UploadedBy {
  id: string;
  first_name: string;
  last_name: string;
  scope: string;
  jobRole: string | null;
  email: string;
}

interface Props {
  selectedId?: string | null;
  selectedUserId?: string | null;
  CreatedAt?: string | null;
  setAnchorEl?:any;
  type:string
}

const stripTime = (date: Date): Date => {
  const newDate = new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
};

const formatDate = (date: string | Date) =>
  new Date(date).toISOString(); 

const getDateRange = (start: string, end: string): string[] => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const range: string[] = [];

  if (startDate > endDate) return [];

  const current = new Date(startDate);
  while (current <= endDate) {
    range.push(formatDate(current));
    current.setDate(current.getDate() + 1);
  }

  return range;
};

const useMovetoActiveRef = ({
  selectedId,
  selectedUserId,
  CreatedAt,
  setAnchorEl,
  type,
}: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const referralReducer = (state: any) => state?.referralReducer;

  const referralReducerData = createSelector(referralReducer, (state) => ({
    referralAllDetail: state?.referralAllDetail,
    referralurl: state?.referralAllDetail,
  }));
  const { referralAllDetail } = useSelector(referralReducerData);
  const [isError,setIsError] = useState(false)
  const [dateRange, setDateRange] = useState<string[]>([]);
  const [isMoveToActiveRef, setIsMoveToActiveRef] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const clearDateRange = useCallback(() => setDateRange([]), []);
  const isDateRangeAvailable = dateRange.length > 0;

  useEffect(() => {
    if (!referralAllDetail?.length) return;
    let range: string[] = [];
    const combined: string[] = [];
    if (!combined.length) combined.push(...getDateRange(referralAllDetail[0], referralAllDetail[1]));
    range = Array.from(new Set(combined)).sort();
    setDateRange(range);
    setAnchorEl(false);
    return () => {
      clearDateRange();
      setAnchorEl(false);
    };
    // eslint-disable-next-line
  }, [referralAllDetail, clearDateRange, setAnchorEl]);

  const handleModalClose = useCallback(() => {
    setIsMoveToActiveRef(false);
    clearDateRange();
    setAnchorEl(false);
  }, [clearDateRange, setAnchorEl]);

  const handleMoveSubmission = useCallback(() => {
    if (!selectedDate) return setIsError(!selectedDate);
    const formattedDate = selectedDate.toLocaleDateString("en-GB");
    if(type === 'REJECTED'){
      const payload = {
        status: selectedId ? constant.REFERRAL_STATUS.ACCEPTED : constant.REFERRAL_STATUS.PENDING,
        reason: "REJECT_TO_ACTIVE",
        new_referral_date: formattedDate,
      };
  
      dispatch(rejectRefferalByID(selectedUserId, payload, navigate,dispatch));
    }else{
      navigate(`/referral/create-caseload/${selectedUserId}?new_referral_date=${selectedDate}`);
    }

    dispatch(clearAllReferralDetail())
    handleModalClose()
    setSelectedDate(null);
    // eslint-disable-next-line
  }, [selectedDate, selectedId, selectedUserId, dispatch, navigate, setAnchorEl, clearDateRange]);

  const handleModalConfirm = useCallback(() => {
    if (isDateRangeAvailable) {
      handleMoveSubmission();
    } else if (selectedUserId) {
      dispatch(viewAllReferralDetail({ ReferralId: selectedUserId,range:true }));
    }

    if (CreatedAt) {
      const createdDate = stripTime(new Date(CreatedAt));
      const today = stripTime(new Date());
      const generatedRange: string[] = [];
      while (createdDate <= today) {
        generatedRange.push(formatDate(createdDate));
        createdDate.setDate(createdDate.getDate() + 1);
      }
      setDateRange(generatedRange);
    } else {
      console.error("Invalid CreatedAt date");
    }
    setAnchorEl(false);
  }, [CreatedAt, isDateRangeAvailable, selectedId, dispatch, handleMoveSubmission, setAnchorEl]);

  return {
    dateRange,
    isDateRangeAvailable,
    handleClearDateRange: clearDateRange,
    handleModalClose,
    handleModalConfirm,
    handleMoveSubmission,
    isMoveToActiveRef,
    setisMoveToActiveRef: setIsMoveToActiveRef,
    selectedDate,
    setIsError,
    isError,
    setSelectedDate,
  };
};

export default useMovetoActiveRef;
